import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBathWoman1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBathWoman1"><Path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><Path d="M8.16406 8L5.28906 19.5H7.99964V23H15.9996V19.5H18.7102L15.8352 8H8.16406Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBathWoman1;
